<template>
  <div class="userset-safe">
    <ul>
      <li>
        <div class="label">{{ $t('base_userset_safe.deng_lu_mi_ma') }}</div>
        <div class="info line1">{{ $t('base_userset_safe.jydqghmmlqszfhzmrylz') }}</div>
        <div class="handle">
          <div class="status ok">
            <i class="el-icon-success"></i>
            <span>{{ $t('base_userset_safe.yi_she_zhi') }}</span>
          </div>
          <div class="set" @click="changePwdDialog">
            <span>{{ $t('Common.com_modify') }}</span>
          </div>
        </div>
      </li>
      <li>
        <div class="label">{{ $t('base_userset_safe.you_xiang') }}</div>
        <div class="info line1">{{ $t('base_userset_safe.yymmzhykzwiSynergyzh') }}</div>
        <div class="handle">
          <div class="status ok" v-if="oldEmail">
            <i class="el-icon-success"></i>
            <span>{{ $t('base_userset_safe.yi_she_zhi') }}</span>
          </div>
          <div class="status" v-else>
            <i class="el-icon-warning"></i>
            <span>{{ $t('base_userset_safe.wei_she_zhi') }}</span>
          </div>
          <div class="set" @click="changeEmailDialog">
            <span>{{ $t('Common.com_modify') }}</span>
          </div>
        </div>
      </li>
    </ul>
    <!--修改密码 -->
    <usersetResetPassword v-if="visible" @close="visible = false"></usersetResetPassword>
    <!-- 修改邮箱弹窗 -->
    <custom-dialog :title="$t('base_userset_safe.xiu_gai_you_xiang')" :visible="emailVisible" @close="emailVisible = false">
      <div class="dialog-body">
        <el-form :model="form" :inline="true" label-width="110px">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('base_userset_safe.you_xiang')">
                <el-input v-model="email" :placeholder="$t('base_userset_safe.qsryx')" style="width:418px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emailVisible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="changeEmail">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import usersetResetPassword from '@/pages/base/components/resetPwdDialog.vue';

export default {
  components: {
    usersetResetPassword
  },
  data() {
    return {
      visible: false,
      form: {
        originalPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      emailVisible: false,
      oldEmail: '',
      email: ''
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    const userInfo = this.$store.state.userInfo;
    this.oldEmail = userInfo.email;
    //
  },
  methods: {
    changePwdDialog: function () {
      this.form = JSON.parse(this.resetForm);
      this.visible = true;
    },
    changeEmailDialog: function () {
      this.email = '';
      this.emailVisible = true;
    },
    // 修改绑定邮箱
    changeEmail: function () {
      this.$postJSON(apis.UserEmail, { email: this.email }, true)
        .then(() => {
          this.emailVisible = false;
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.userset-safe {
  padding: 16px 32px;
  ul li {
    height: 80px;
    line-height: 80px;
    display: flex;
    border-bottom: 1px dashed #e1e6eb;
    padding-right: 80px;
    .label {
      width: 152px;
      padding-left: 24px;
      color: #2c405e;
      font-size: 12px;
      font-weight: bold;
    }
    .info {
      flex: 1;
      font-size: 12px;
      color: #879cbb;
    }
    .handle {
      display: flex;
      align-items: center;
      .status {
        color: #ff9902;
        padding-right: 10px;
        &.ok {
          color: #029901;
        }
        i {
          font-size: 19px;
          margin-right: 10px;
          float: left;
          line-height: 79px;
        }
        span {
          font-size: 12px;
        }
      }
      .set {
        cursor: pointer;
        padding-left: 10px;
        color: #0266cc;
        font-size: 12px;
        height: 14px;
        line-height: 14px;
        border-left: 1px solid #cccccc;
      }
    }
  }
}
</style>
